import React, { Component } from 'react';
import ModalPopover from '../../../../../../components/ZUILib/ModalPopover';
// import commonUtil from '../../../../../../utils/commonUtil';

export default class ConfirmDeleteOwnerPopUp extends Component {
  handleShow = () => {
    this.modal.handleShow();
  }
  handleHide = () => {
    this.modal.handleHide();
  }
  cancel = () => {
    this.handleHide();
    this.props.confirmationRejectedCB();
  }
  accepted = () => {
    this.handleHide();
    this.props.confirmationAcceptedCB();
  }
  render() {
   // const lables = this.props.lables;
    const cele = this.props.celebrity;
    let name = '';
    if (cele.firstName) {
      name += cele.firstName;
    }
    if (cele.motherName) {
      name += ' ' + cele.motherName;
    }
    if (cele.lastName) {
      name += ' ' + cele.lastName;
    }
    return (
      <ModalPopover isModal="true" modalClass="centerModal" ref={modal => this.modal = modal}>
        <i id="closeModal" className="icon-cerrar close" data-dismiss="modal" aria-label="Close" />
        <p> ¿Estás seguro? Quieres eliminar <strong>{name}</strong> del evento</p>
        <div className="row">
          <div className="col-xs-6">
            <button
              id="closeModal"
              className="btnSecondaryAction size-Full closeModal"
              data-dismiss="modal"
              onClick={this.cancel}
            >Cancelar</button>
          </div>
          <div className="col-xs-6">
            <button
              className="btnPrimaryAction size-Full"
              data-dismiss="modal"
              onClick={this.accepted}
            >Aceptar</button>
          </div>
        </div>
      </ModalPopover>
    );
  }

}
